import { Button } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import AlertComponent from '@components/modal/Alert.component';

interface ConfirmModalProps {
  description?: string;
  handleClose: () => void;
  handleValidate: (handleStopLoading: () => void) => void;
  title?: string;
  validateButton: string;
}

const ConfirmModal = (props: ConfirmModalProps) => {
  const { description, handleClose, handleValidate, title, validateButton } = props;

  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  return (
    <AlertComponent
      title={title}
      description={description}
      handleClose={handleClose}
      actions={(
        <>
          <Button variant="outlined" color="primary" disabled={loading} onClick={handleClose}>
            {t('global.cancel')}
          </Button>
          <Button
            variant="contained"
            disabled={loading}
            color="primary"
            onClick={() => {
              setLoading(true);
              handleValidate(() => setLoading(false));
            }}>
            {validateButton}
          </Button>
        </>
      )} />
  );
};

export default ConfirmModal;
